import React, { useEffect, useState } from "react";
// import Captcha from "./Captcha";
import "bootstrap/dist/css/bootstrap.min.css";
import userimg from "../assets/images/user.png";
import PragyanCircle from "../assets/images/logo-circle.svg";
import DVP from "../assets/images/DIS.png";
import CEDA from "../assets/images/ceda-logo.png";
import NICSI from "../assets/images/nicsi_logo.svg";
import Email from "../assets/images/email.png";
import User from "../assets/images/user-ic.png";
import { AddUser } from "../services/api";
import { fetchCaptcha } from "../services/api";
import Refresh from "../assets/images/refresh.svg";

const Signup = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
  });
  const [chaptchaTextValue, setChaptchaTextValue] = useState("");
  const [chaptchValue, setChaptchValue] = useState("");
  const [captchaId, setCaptchaId] = useState();
  const [message, setMessage] = useState("");
  const [isDisabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    setIsLoading(true);

    try {
      const response = await fetch(AddUser.ADD_USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        setIsLoading(false);
        setDisabled(false);
        throw new Error("Network response was not ok");
      }
      setIsLoading(false);
      setDisabled(false);
      console.log("User added successfully!");
      setFormData({ first_name: "", last_name: "", username: "", email: "" });
    } catch (error) {
      setIsLoading(false);
      setDisabled(false);
      console.error("Error:", error);
    }
  };

  const handleCaptchaChange = (id, text) => {
    setFormData({ ...formData, captchaId: id, captchaText: text });
  };

  const loadCaptcha = async () => {
    const data = await fetchCaptcha();
    if (data) {
      setChaptchValue(data.captcha_text);
      setCaptchaId(data.captcha_id);
      handleCaptchaChange(data.captcha_id, data.captcha_text);
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleRefresh = async () => {
    setChaptchaTextValue("");
    loadCaptcha();
  };

  const handleCapcha = (e) => {
    setMessage("");
    setChaptchaTextValue(e.target.value);
  };

  return (
    <div>
      <div className="signup_bg signup">
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}
        <div className="container-fluid h-100">
          <div className="row outer_bg h-100">
            <div className="order-2 order-md-1 col-sm-12 col-md-6 col-lg-6 text-center">
              <div className="line"></div>
              <div className="dis_form_container">
                <div className="dis_form">
                  <div className="dis_form_heading">
                    <div>
                      <h2>Sign Up</h2>
                    </div>
                    <div className="heading_user_img">
                      <img src={userimg} alt="user icon" />
                    </div>
                  </div>
                  <div className="signup_form">
                    {message && (
                      <div className="alert alert-danger">{message}</div>
                    )}
                    <form className="form-row" onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                FIRST NAME
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={User} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  name="first_name"
                                  value={formData.first_name}
                                  onChange={handleInputChange}
                                  className="form-control custom-rounded-input"
                                  placeholder="First Name"
                                  required
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                LAST NAME
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={User} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  name="last_name"
                                  value={formData.last_name}
                                  onChange={handleInputChange}
                                  className="form-control custom-rounded-input"
                                  placeholder="Last Name"
                                  required
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                USERNAME
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={User} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  name="username"
                                  value={formData.username}
                                  onChange={handleInputChange}
                                  className="form-control custom-rounded-input"
                                  placeholder="Username"
                                  required
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                EMAIL
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={Email} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  className="form-control custom-rounded-input"
                                  placeholder="Email"
                                  required
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="captcha d-flex justify-content-center">
                        <div className="mb-3">
                          <div className="captcha d-flex align-items-center">
                            <span className="captcha-text p-1 border">
                              {chaptchValue}
                            </span>
                            <input
                              type="text"
                              className="form-control noRound"
                              onChange={handleCapcha}
                              placeholder="Enter Captcha"
                              required
                              value={chaptchaTextValue}
                            />
                            <button
                              type="button"
                              className="btn refreshBtn"
                              onClick={handleRefresh}
                            >
                              <img src={Refresh} alt="refresh" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <button
                        type="submit"
                        className="btn submit_btn"
                        mat-button
                        disabled={isDisabled}
                      >
                        Sign Up
                      </button>

                      <div className="sign_up">
                        <p className="mb-0">
                          Already have an account?{" "}
                          <a href="/signin" className="signin_text">
                            Sign In
                          </a>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 order-md-2 col-sm-12 col-md-6 col-lg-6 text-center my-4">
              <div className="dis_title">
                <div className="pragyan_logo_circle">
                  <img src={PragyanCircle} alt="Pragyan" />
                </div>
                <div className="dis_title_image mt-3">
                  <a href="#">
                    <img src={DVP} alt="Data Integration Services" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer_inner">
          <div className="footer_line"></div>
          <div className="footer">
            <div className="row adm_row">
              <div className="col-sm-2 col-md-2 px-0">
                <div className="ceda_logo">
                  <img src={CEDA} alt="" />
                </div>
              </div>
              <div className="col-sm-8 col-md-8">
                <div className="footer_title">
                  <p>
                    Data Integration & Exploration Platform, Designed &
                    Developed by
                  </p>
                  <p>
                    <span>
                      CENTRE OF EXCELLENCE FOR DATA ANALYTICS (CEDA), NICSI
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-sm-2 col-md-2 px-0">
                <div className="nicsi_logo">
                  <img src={NICSI} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
